import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token (fallback when cookies are unavailable)
const stored = localStorage.getItem("yd_token");
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export const setToken = (token) => {
  if (token) {
    localStorage.setItem("yd_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("yd_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

export const apiErr = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
};

export default api;
